exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .NIau5C8gtCT98b\\+mCAPckw\\=\\={margin:10px 0}", ""]);
// Exports
exports.locals = {
	"mailListLoading": "NIau5C8gtCT98b+mCAPckw=="
};